module.exports = __webpack_public_path__ + "img/powered-by-dark.3a28821c.svg";